import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { FssTheme } from './fss-theme';
import { MessageService } from 'primeng/api';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { API_BASE_URL } from '../infrastructure/shared/model/fss.api';
import { environment } from '../environment/environment';
import { errorInterceptor } from '../infrastructure/shared/interceptors/error.interceptor';
import { refreshTokenInterceptor } from '../infrastructure/shared/interceptors/refresh-token.interceptor';
import { loaderInterceptor } from '../infrastructure/shared/interceptors/loader.interceptop';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { localeInterceptor } from '../infrastructure/shared/interceptors/locale.interceptor';
import { AuthService } from '../infrastructure/shared/services/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
    provideHttpClient(
      withInterceptors([
        localeInterceptor,
        errorInterceptor,
        refreshTokenInterceptor,
        loaderInterceptor,
      ]),
    ),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    providePrimeNG({
      theme: {
        preset: FssTheme,
        options: {
          prefix: 'p',
          cssLayer: false,
          darkModeSelector: '.fss-app-dark',
        },
      },
      translation: {
        firstDayOfWeek: 1,
        dayNames: ['Nedelja', 'Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota'],
        dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
        dayNamesMin: ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
        monthNames: [
          'Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun',
          'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar',
        ],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
        today: 'Danas',
        clear: 'Obriši',
      },
    }),
    MessageService,
    JwtHelperService,
    // Restarts the SignalR connection on a hard page reload for an already-logged-in
    // user — otherwise it only ever starts right after an interactive login.
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      if (authService.isUserAuthenticated()) {
        authService.startSignalR();
      }
    }),
  ]
};
